export type EmojiLocale = 'fi' | 'en';

export type SkinTone = 'light' | 'medium-light' | 'medium' | 'medium-dark' | 'dark';

export const SKIN_TONES: readonly SkinTone[] = [
  'light',
  'medium-light',
  'medium',
  'medium-dark',
  'dark',
] as const;

export interface EmojiEntry {
  emoji: string;
  label: string;
  group: string;
  subgroup: string;
  keywords: string[];
  hasSkinTone: boolean;
  skinToneVariants?: string[];
}

export interface EmojiGroup {
  key: string;
  label: string;
  entries: EmojiEntry[];
}
